import { render, staticRenderFns } from "./MGMT_TRGTS.vue?vue&type=template&id=009bbf0a&scoped=true"
import script from "./MGMT_TRGTS.vue?vue&type=script&lang=ts"
export * from "./MGMT_TRGTS.vue?vue&type=script&lang=ts"
import style0 from "./MGMT_TRGTS.vue?vue&type=style&index=0&id=009bbf0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009bbf0a",
  null
  
)

export default component.exports